module.exports = __webpack_public_path__ + "static/img/hr-qrcode.57d3b8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/about-us/hr-qrcode.png
// module id = p4So
// module chunks = 4